module.exports = __webpack_public_path__ + "static/img/monocromo-blanco_mineduc-d1f83e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/monocromo-blanco_mineduc.png
// module id = CP5N
// module chunks = 1